// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__16xn9","actions":"GroupTable_actions__3Z4NM","deleteModalFooter":"GroupTable_deleteModalFooter__36JDY"};